export const widgetsHubPage = () =>
  import("./WidgetsHubPage").then((m) => ({ Component: m.WidgetsHubPage }));
